var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"pax-loading-modal"},[_c('div',{staticClass:"pax-loading-modal__spinner"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }